import React, {Component} from 'react';

import Spinner from '../../../../components/Spinner';



import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import './style.css';

const easyFilter = [

	{	
		displayKey: '포함',
        displayName: '키워드 포함',
        test: function(filterValue, cellValue) {
          if (cellValue == null) return false;
          return cellValue.indexOf(filterValue) >= 0;
        },
    },
    {	
    	displayKey: '일치',
        displayName: '키워드 일치',
        test: function(filterValue, cellValue) {
          
          return filterValue == cellValue;
        },
    }

];

const numberFilter = [

	{	
		displayKey: '이상',
        displayName: '이상',
        test: function(filterValue, cellValue) {
        	return Number(filterValue) <= Number(cellValue);
        },
    },
    {	
    	displayKey: '이하',
        displayName: '이하',
        test: function(filterValue, cellValue) {
          return Number(filterValue) >= Number(cellValue);
        },
    },
    {	
    	displayKey: '일치',
        displayName: '일치',
        test: function(filterValue, cellValue) {
          return Number(filterValue) == Number(cellValue);
        },
    }

]


export default class BranchList extends Component {


	constructor(props) {
		super(props);
		this.state = {
			year : this.props.year,
			classList : this.props.classList
		}
	}
    
    listColumn = [
		{
		    headerName: "클래스명",
		    field: "name",
		    sortable: false,
		    minWidth : 135,
		    cellClass: "text-center",
		    resizable : true,
		    filter: "agTextColumnFilter",
		    filterParams: {
        		filterOptions: easyFilter
        	},
        	cellClassRules: { 
        		'show-cell': (params) => {
        			return params.data.app_name === '토모노트' && params.data.app_num > 1;
        		}
        	},
        	rowSpan: function(params) {
        		
	            if (params.data.app_num > 1) {	
	            	return params.data.app_num;
	            } else {
	            	return 1;
	            }
	        },
	        cellRenderer : (params) => {
	        	if(params.data.app_name !== '토모노트' && params.data.app_num <= 1) {
	        		return null;
	        	} else {
	        		return params.value;
	        	}
	        }
		},
		{
		    headerName: "앱",
		    field: "app_name",
		    sortable: false,
		    minWidth : 135,
		    cellClass: "text-center",
		    filter: "agTextColumnFilter",
		    filterParams: {
        		filterOptions: numberFilter
        	}
		},
		{
		    headerName: "연령",
		    field: "age",
		    sortable: false,
		    minWidth : 135,
		    cellClass: "text-center",
		    filter: "agTextColumnFilter",
		    filterParams: {
        		filterOptions: numberFilter
        	}
		},
		{
		    headerName: "앱 활용 지수",
		    field: "app_score",
		    sortable: false,
		    minWidth : 135,
		    cellClass: "text-center",
		    filter: "agTextColumnFilter",
		    filterParams: {
        		filterOptions: numberFilter
        	}
		},
		{
		    headerName: "컨텐츠 지수",
		    field: "content_score",
		    sortable: false,
		    minWidth : 150,
		    cellClass: "text-center",
		    filter: "agTextColumnFilter",
		    filterParams: {
        		filterOptions: numberFilter
        	}
		},
		{
		    headerName: "앱 버전",
		    field: "version",
		    sortable: false,
		    minWidth : 135,
		    cellClass: "text-center",
		    filter: "agTextColumnFilter",
		    filterParams: {
        		filterOptions: numberFilter
        	}
		},
		{
		    headerName: "단말 정보",
		    field: "device",
		    sortable: false,
		    minWidth : 135,
		    cellClass: "text-center",
		    filter: "agTextColumnFilter",
		    filterParams: {
        		filterOptions: numberFilter
        	}
		}
	];
	



	onGridReady = params => {
        params.api.sizeColumnsToFit();
    }

	render() {
		if (this.state.classList== null) {
			return(
				<div className="card">
	                <div className="card-body" style={{height: this.props.height+ "px", textAlign:"center", paddingTop:"50px"}}>
                        <span className="dashboard-spinner spinner-xxl"></span>
                    </div>
	            </div>
			)
		} else if(this.state.classList.length == 0) {
			return(
				<div className="card">
	                <div className="card-body" style={{height: this.props.height+ "px"}}>
	                    No Data
	                </div>
	            </div>
			)
		} else {
			return(
				<div className="card">
	                <div className="card-body" style={{padding : "0px"}}>
						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ag-theme-alpine"  style={{height: this.props.height+ "px", padding : "0px"}}>
							<AgGridReact
					          columnDefs={this.listColumn}
					          rowData={this.state.classList}			
					          suppressRowTransform={true}
					          onGridReady={this.onGridReady}
					          
					        >
					        </AgGridReact>
						</div>
	                    
	                </div>
	            </div>
			)
		}

	}

}